import { render } from "./NegotiationCard.vue?vue&type=template&id=21c15bbc&scoped=true&ts=true"
import script from "./NegotiationCard.vue?vue&type=script&lang=ts"
export * from "./NegotiationCard.vue?vue&type=script&lang=ts"

import "./NegotiationCard.vue?vue&type=style&index=0&id=21c15bbc&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c15bbc"]])

export default __exports__